// Main application module
angular.module('app',
    [
        // external modules
        'ui.router',
        'gettext',

        // external UI modules
        'ngAnimate',
        'ngTouch',
        'kendo.directives',

        // project env modules
        'env',

        // project ui modules
        'ui',

        // common controls and directives
        'common'
    ])
    .controller('AppController', function AppController($scope) {
        // main controller. Do not delete!

        //Disable accepting drag'n'dropped files in out window
        //Drop should happen only in the designated zones
        //We don't want the browser to open accidently dropped files
        window.addEventListener("dragover", function (e) {
            e = e || event;
            e.preventDefault();
        }, false);
        window.addEventListener("drop", function (e) {
            e = e || event;
            e.preventDefault();
        }, false);
    })

    .config(function config($compileProvider) {
        if (!om.config.debug && $compileProvider.debugInfoEnabled) $compileProvider.debugInfoEnabled(false);
    })

    ;
